import _ from "lodash";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import { isNullOrUndefined } from 'util';
//import moment from "moment";
const moment = require('moment-timezone'); 

export default {
  name: "VestingScheduleDatesMixin",
  methods: {
    _getVestingDates(Transaction, VestingScheduleResponse) {
      if (VestingScheduleResponse) {
        let VestingScheduleFilteredData=_.filter(VestingScheduleResponse, function(vsItem) {
          return vsItem.UnitType == Transaction.UnitType && vsItem.VestingType == Transaction.VestingType
          });
          VestingScheduleFilteredData.forEach(element => {
          switch (true) {
            case element.VestingType == "Standard" && element.Year == 0:
              Transaction.VestStartDate = element.VestDate
              break;
            case element.VestingType == "Standard" && element.Year == 1:
              Transaction.VestYear1Date = element.VestDate
              break;
            case element.VestingType == "Standard" && element.Year == 2:
              Transaction.VestYear2Date = element.VestDate
              break;
            case element.VestingType == "Standard" && element.Year == 3:
              Transaction.VestYear3Date = element.VestDate
              break;
            case element.VestingType == "Standard" && element.Year == 4:
              Transaction.VestYear4Date = element.VestDate
              break;
            case element.VestingType == "Cliff":
              Transaction.VestCliffDate = element.VestDate
              break;
            default:
              break;
          }
        });
      }
    },

    _updateHireDate(Transaction) {
      let partnerHireDate = new Date();
      let partnerVestStartDate = new Date(Transaction.VestStartDate);
      let PartnerFilterQuery = null;
      let selectedPartner={};

      if(Transaction.BusinessEvent == "Issuance"){
        PartnerFilterQuery = { filter: "Id eq " + Transaction.ReceiverId};
      } 
      else if(Transaction.BusinessEvent == "Transfer"){
        PartnerFilterQuery = { filter: "Id eq " + Transaction.SenderId};
      }

      if(!isNullOrUndefined(PartnerFilterQuery)) {
        selectedPartner = this.withFilter(BaseModelPartner.list, PartnerFilterQuery);
      }
      if(selectedPartner && selectedPartner.length) {
        partnerHireDate = new Date(selectedPartner[0].HireDate);
      }

      if(!isNullOrUndefined(partnerHireDate) && !isNullOrUndefined(partnerVestStartDate)){
        let temp = this._getDateDiffinDays(partnerHireDate, partnerVestStartDate);
        let VestStartDate  = _.clone(partnerHireDate);
        if(temp> 0 && temp< 365){
          Transaction.VestStartDate = this._convertTimeZone(VestStartDate);
          Transaction.VestYear1Date = this._convertTimeZone(new Date(partnerHireDate.setMonth(partnerHireDate.getMonth()+12)));
          Transaction.VestYear2Date = this._convertTimeZone(new Date(partnerHireDate.setMonth(partnerHireDate.getMonth()+12)));
          Transaction.VestYear3Date = this._convertTimeZone(new Date(partnerHireDate.setMonth(partnerHireDate.getMonth()+12)));
          Transaction.VestYear4Date = this._convertTimeZone(new Date(partnerHireDate.setMonth(partnerHireDate.getMonth()+12))); 
        }
      }
    },

    _getDateDiffinDays: function(date1, date2) {
        let dt1 = new Date(date1);
        let dt2 = new Date(date2);
        return Math.floor(
          (Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) -
            Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate())) /
            (1000 * 60 * 60 * 24)
        );
    },
    _convertTimeZone(InputDate){
        return moment.tz(InputDate, "America/New_York").format("MM/DD/YYYY");
      } 
  }
}